module.exports = __webpack_public_path__ + "static/img/Callum_Mills_desktop.c9e69eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Callum_Mills_desktop.jpg
// module id = EXdr
// module chunks = 0